const mutableRuntimeProperties = ['apiUrl', 'apiURL', 'apiURLSSL'];

export default mutableRuntimeProperties;
